module.exports = __webpack_public_path__ + "img/fm-f-Path 52@3x.b8e40860.png";